import Vue from 'vue';
import VueRouter from 'vue-router';
import Heatmap from '../views/Heatmap.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Heatmap,
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
